import palette from "../theme/palette";

export const QuillStyle = {
  border: `1px solid ${palette.grey[500_32]}`,
  borderRadius: "8px",
  minHeight: "100px",
};
